import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import axiosInstance from '../../api/api';
import { API_ROUTES } from '../../config/api-routes';
import { getUserFacingError } from '../../utils/userFacingError';
import './FeedbackButton.css';

const HelpButton: React.FC = () => {
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!message.trim() || submitting) return;

    const comment = [
      `[Help request]`,
      `Page: ${location.pathname}${location.search}`,
      '',
      message.trim(),
    ].join('\n');

    setSubmitting(true);
    try {
      await axiosInstance.post(
        API_ROUTES.USER.POST_USER_FEEDBACK,
        { comment },
        { suppressErrorToast: true }
      );
      setMessage('');
      setOpen(false);
      setSubmitted(true);
      toast.success('Thanks — we received your message and will follow up.');
      setTimeout(() => setSubmitted(false), 3000);
    } catch (err) {
      toast.error(
        getUserFacingError(err, 'We could not send your message. Please try again in a moment.')
      );
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <button
        type="button"
        className={`help-fab${submitted ? ' help-fab--success' : ''}${open ? ' help-fab--open' : ''}`}
        onClick={() => !submitted && setOpen((prev) => !prev)}
        disabled={submitted}
        aria-expanded={open}
        aria-haspopup="dialog"
      >
        {submitted ? 'Message sent' : 'Get Help'}
      </button>

      {open && !submitted ? (
        <form
          className="help-fab-panel"
          onSubmit={handleSubmit}
          aria-label="Contact SkipScreen support"
        >
          <h4 className="help-fab-panel__title">Get Help</h4>
          <p className="help-fab-panel__hint">
            Ran into an error or something not working? Tell us what happened and we will get back
            to you.
          </p>
          <textarea
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            placeholder="Describe the issue, what you clicked, and any error message you saw…"
            required
          />
          <button type="submit" disabled={submitting || !message.trim()}>
            {submitting ? 'Sending…' : 'Send message'}
          </button>
        </form>
      ) : null}
    </>
  );
};

export default HelpButton;
